import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

interface ConfirmModalProps {
  show: boolean;
  setDate?: any;
  count?: any;
  message?: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const SearchRequestModal: React.FC<ConfirmModalProps> = ({
  show,
  setDate,
  count,
  loading = false,
  onConfirm,
  onCancel,
}) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { id, value } = event.target;
    setDate((prev: any) => ({ ...prev, [id]: value }));

  };

  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header
        closeButton
        style={{ background: "var(--color-profile-1)", color: "black" }}
      >
        <Modal.Title>Consultar N° de peças</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex gap-4 align-items-center justify-content-center m-2">
          <div className="col-6">
            <label htmlFor="">Data Inicial</label>
            <input type="date" id="dt_inicial" className="form-control" onChange={handleChange} />
          </div>
          <div className="col-6">
            <label htmlFor="">Data Final</label>
            <input type="date" id="dt_final" className="form-control"  onChange={handleChange}/>
          </div>
        </div>

        <div className="d-flex gap-4 align-items-center justify-content-center m-2">
          <div className="col-6">
            <label htmlFor="">N° de pedidos</label>
            <input type="text" disabled className="form-control" value={count.count}/>
          </div>
          <div className="col-6">
            <label htmlFor="">Total</label>
            <input type="text" disabled className="form-control" value={count.value}  />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ background: "var(--color-profile-1)" }}>
        <Button
          variant="secondary"
          size="sm"
          disabled={loading}
          onClick={onCancel}
          style={{ display: "flex", alignItems: "center" }}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          {loading ? (
            <Spinner as="span" animation="border" size="sm" />
          ) : (
            "Voltar"
          )}
        </Button>
        <Button
          variant="primary"
          size="sm"
          disabled={loading}
          onClick={onConfirm}
          style={{ display: "flex", alignItems: "center" }}
        >
          {loading ? (
            <Spinner as="span" animation="border" size="sm" />
          ) : (
            "Confirmar"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SearchRequestModal;
